import * as THREE from 'three';
import { FileLoader } from 'three';

// THREE.TextureLoader doesn't support setRequestHeader method
// Using custom loader to overcome this issue.

export class TextureLoader extends THREE.Loader {
  public timeoutHandle?: NodeJS.Timeout;

  load(
    url: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onLoad: (argument0: any) => void,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onProgress: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (argument0: any) => void
  ) {
    // THREE.Cache.enabled = true;
    const loader = new FileLoader(this.manager);
    // loader.setMimeType('image/jpeg');
    loader.setResponseType('blob');

    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    let retryCount = 0;
    const maxRetries = 5;
    const minInterval = 1_000;
    const maxInterval = 3_000;

    const errors: unknown[] = [];

    const retryLoad = () => {
      loader.load(
        url,
        (data) => {
          try {
            const blobUrl = URL.createObjectURL(data as unknown as Blob);
            const textureLoader = new THREE.TextureLoader();
            textureLoader.load(
              blobUrl,
              (texture) => {
                texture.colorSpace = THREE.SRGBColorSpace;
                onLoad(texture);
              },
              undefined,
              (error) => {
                if (onError) {
                  onError(error);
                } else {
                  throw error;
                }
              }
            );
          } catch (error) {
            if (onError) {
              onError(error);
            } else {
              throw error;
            }
            this.manager.itemError(url);
          }
        },
        onProgress,
        (error) => {
          errors.push(error);
          if (retryCount < maxRetries) {
            const randomInterval =
              minInterval + Math.floor(Math.random() * (maxInterval - minInterval));
            this.timeoutHandle = setTimeout(retryLoad, randomInterval);
            retryCount++;
          } else {
            const combinedError = new Error(`Unable to load image: ${url} Errors: ${errors}`);
            if (onError) {
              onError(combinedError);
            } else {
              throw combinedError;
            }
          }
        }
      );
    };

    retryLoad();
  }

  dispose() {
    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
    }
  }
}
